import React from 'react';
import { Colors, googleMapsKey, getUrlWithUtmQueryString } from '@capcenter/shared';
import { Button } from '@capcenter/shared-legacy';
import Extensions from './Extensions';
import LocationInt from './Location.interface';
import moment from 'moment';
import 'moment-timezone';
import IsHoliday from './IsHoliday';

const initialState = { open: false };
type State = Readonly<typeof initialState>;

export class Location extends React.Component<LocationInt> {
  readonly state: State = initialState;

  componentDidMount() {
    this.isOpen();
    this.checkEveryMinute();
  }

  checkEveryMinute = () => {
    const oneMinute: number = 60 * 1000;

    function repeatEvery(func: Function, interval: number) {
      // Check current time and calculate the delay until next interval
      const now: Date = new Date();
      const nowNum: number = now.getTime();
      const delay: number = interval - (nowNum % interval);

      function start() {
        // Execute function now...
        func();
        // ... and every interval
        setInterval(func, interval);
      }

      // Delay execution until it's an even interval
      setTimeout(start, delay);
    }

    repeatEvery(this.isOpen, oneMinute);
  };

  isOpen = () => {

    //OPEN LOGIC

    const timeNow = moment().tz('America/New_York').format();
    const timeOpen = moment(this.props.opens + 'am', 'h:mm a').format();
    const timeClosed = moment(this.props.closes + 'pm', 'h:mm a').format();
    const isOpen = moment(timeNow).isBetween(timeOpen, timeClosed);
    const isWeekend = moment().day() === 0 || moment().day() === 6;
    const isHoliday = IsHoliday();

    let open = false;

    if (isOpen && !isHoliday && !isWeekend) {
      open = true;
    }

    if (open !== this.state.open) {
      this.setState({ open });
    }
  };

  render() {
    const props = this.props;

    let addressUrl: string = '';

    if (props.address) {
      props.address.map(line => {
        addressUrl = addressUrl + line.toString() + ' ';
        return null;
      });
    }

    return (
      <div className="row" style={{ paddingTop: 15, paddingBottom: 15 }}>
        <div className="col-4">
          {props.image ? (
            props.image
          ) : props.address ? (
            <img
              className="img-fluid"
              src={
                'https://maps.googleapis.com/maps/api/streetview?size=500x500&location=' +
                props.address[0].replace('#', '').split(' ').join('+') +
                '+' +
                props.address[1].replace('#', '').split(' ').join('+') +
                '&key=' +
                googleMapsKey
              }
              alt={props.title}
            />
          ) : (
            <></>
          )}
        </div>
        <div className="col-8">
          <h4 style={{ marginBottom: 2 }}>
            <a href={getUrlWithUtmQueryString(props.link)} style={{color: "#0C2C48"}} target="_blank" rel="noreferrer noopener">{props.title}</a> -&nbsp;
            {this.state.open ? (
              <span style={{ color: Colors.green500 }}>OPEN</span>
            ) : (
              <span style={{ color: Colors.red500 }}>CLOSED</span>
            )}
          </h4>
          { props.isByAppointmentOnly ? `By appointment only\n\n` : "" }
          { props.isByAppointmentOnly ? <br/> : "" }
          {`Monday - Friday, ${props.opens} am - ${props.closes} pm`}
          <br />
          {props.phoneNumber && (
            <div className="btn-group d-flex" style={{ marginTop: 5 }}>
              <Button
                className="flex-fill"
                icon={['icon', 'phone']}
                text={props.phoneNumber}
                href={'tel:' + props.phoneNumber}
              />

              {props.extensions && (
                <Extensions last={props.last} extensions={props.extensions} phoneNumber={props.phoneNumber} />
              )}
            </div>
          )}
          {props.email && (
            <Button
              style={{ marginTop: 5 }}
              className="btn-block"
              color={Colors.teal600}
              icon="envelope"
              text="Send us an email"
              href={props.email.url}
            />
          )}
          {props.call && (
            <Button
              style={{ marginTop: 5 }}
              className="btn-block"
              color={Colors.teal600}
              icon="calendar"
              text="Schedule a call"
              href={props.call.url}
              target="_blank"
            />
          )}
          {props.address && (
            <Button
              style={{ marginTop: 5 }}
              color={Colors.teal600}
              text=""
              className="btn-block"
              href={'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addressUrl)}
              target="_blank"
            >
              <div className="d-flex justify-content-center align-items-center">
                <i className="fas fa-directions" style={{ fontSize: '1.4rem', marginRight: 10 }} />

                <div className="text-left" style={{ lineHeight: 1, fontSize: '.85rem'}}>
                  {props.address.map((line, i) => (
                    <span key={i}>
                      {line}
                      <br />
                    </span>
                  ))}
                </div>
              </div>
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default Location;
